import { RenderTexture, Sprite, Texture, type Renderer } from 'pixi.js';

export function bakeRotatedTexture(renderer: Renderer, source: Texture): Texture {
  const rt = RenderTexture.create({ width: source.height, height: source.width });
  const sprite = new Sprite(source);
  sprite.anchor.set(0.5);
  sprite.rotation = -Math.PI / 2;
  sprite.position.set(rt.width / 2, rt.height / 2);
  renderer.render({ container: sprite, target: rt });
  sprite.destroy();
  return rt;
}
